<template>
  <div class="center_right right_auth">
    <!-- 导航条 -->
    <div class="center_tag">
      <ul class="left">
        <li
          v-for="nav in [
            { title: '老师', id: 'dubber' },
            { title: '声音', id: 'voice' },
            { title: '合辑', id: 'album' },
          ]"
        >
          <a
            href="javascript:;"
            :class="type == nav.id ? 'on' : ''"
            @click="changeType(nav.id)"
            >{{ nav.title }}</a
          >
        </li>
      </ul>
      <ul class="right">
        <li>
          <a
            class="all"
            :class="{ on: isSelectedAll }"
            v-show="waitingSelect"
            @click="checkAll"
            >{{ isSelectedAll ? "取消全选" : "全选" }}</a
          >
          <a class="delete" v-show="waitingSelect" @click="doDelete()"
            ><i class="fa fa-trash-o"></i>删除</a
          >
          <button class="batch" @click="typeChange()">
            {{ waitingSelect ? "取消" : "批量管理" }}
          </button>
        </li>
        <li>
          <input
            type="text"
            placeholder="输入搜索关键字"
            @keydown.enter="searchItem"
            v-model="searchKey"
          />
        </li>
        <li>
          <button class="search" @click="searchItem">搜索</button>
        </li>
      </ul>
    </div>
    <!-- 内容区 -->
    <div class="center_content" :class="{ 'waiting-select': waitingSelect }">
      <!-- 老师 -->
      <div class="tea-wrap" v-show="type == 'dubber'">
        <div v-for="d in datas.dubber" class="hsktea-recom-wrap lf">
          <div class="opacity" @click="selectItem(d)">
            <i class="select" :class="{ on: isSelected(d) }"></i>
          </div>
          <div class="hsktea-recom-itmes">
            <div class="recom-items-top">
              <div class="hsktea-pic">
                <a :href="'/dubbing/detail/' + d.dubbingId" target="_blank"
                  ><img :src="imgPath(d.dubbingHead)"
                /></a>
              </div>
              <div class="hsktea-info">
                <a
                  class="hsktea-num lf hl"
                  :href="'/dubbing/detail/' + d.dubbingId"
                  target="_blank"
                  >{{ d.dubbingName }}</a
                >
                <p>交易量：{{ d.tranCount }}</p>
                <p class="dis_n">已合作老师</p>
              </div>
              <a
                :href="
                  'https://sd235.oss-cn-shanghai.aliyuncs.com/rar/downloads/' +
                  d.userNumber +
                  '.zip'
                "
              >
                <div class="hsktea-download" title="下载样音包"></div>
              </a>
            </div>
            <div class="hsktea-price">
              <a href="javascript:;">
                <span v-if="d.minPrice == 1" class="hsktea-price-title"
                  >专题：<span class="hsktea-price-num">一元配音</span></span
                >
                <span v-else-if="d.minPrice <= 0" class="hsktea-price-title"
                  >专题：<span class="hsktea-price-num">暂无报价</span></span
                >
                <span v-else-if="d.minPrice >= 10000" class="hsktea-price-title"
                  >专题：<span class="hsktea-price-num">联系客服</span></span
                >
                <template v-else>
                  <span class="hsktea-price-title">专题:</span> ￥<span
                    class="hsktea-price-num"
                    >{{ d.minPrice }}</span
                  ><span
                    v-html="d.language != '普通话' ? '/百词' : '/分'"
                  ></span>
                </template>
              </a>
              <a href="javascript:;">
                <span v-if="d.adPrice == 1" class="hsktea-price-title"
                  >广告：<span class="hsktea-price-num">一元配音</span></span
                >
                <span v-else-if="d.adPrice <= 0" class="hsktea-price-title"
                  >广告：<span class="hsktea-price-num">暂无报价</span></span
                >
                <span v-else-if="d.adPrice >= 10000" class="hsktea-price-title"
                  >广告：<span class="hsktea-price-num">联系客服</span></span
                >
                <template v-else>
                  <span class="hsktea-price-title">广告:</span> ￥<span
                    class="hsktea-price-num"
                    >{{ d.adPrice }}</span
                  >/30秒
                </template>
              </a>
            </div>
            <div class="hsktea-dub kf_btn">
              <a href="javascript:;">立即配音</a>
              <div class="kf_list_wrap">
                <div class="kf_list">
                  <div class="arrow_top">
                    <div class="arrow_inner"></div>
                  </div>
                  <ul></ul>
                </div>
              </div>
            </div>
            <div
              class="collect"
              :class="d.hasCollect ? 'on' : ''"
              @click="singleCollect(d)"
            >
              <p v-if="d.hasCollect">取消收藏{{ d.aa }}</p>
              <p v-else="d.hasCollect">收藏</p>
            </div>
          </div>
        </div>
        <div class="empty_cop" v-if="datas.dubber.length == 0">
          <p class="info">您暂无添加收藏过的老师哦~</p>
          <a href="/dubbing">去看看 >></a>
        </div>
      </div>
      <div class="sea-voice-wrap" v-show="type == 'voice'">
        <!-- 声音 -->
        <ul>
          <li
            v-for="(d, index) in datas.voice"
            :sound-id="d.voiceId"
            :dubber-id="d.dubbingId"
            class="voice-items"
          >
            <i
              class="select"
              @click="selectItem(d)"
              :class="{ on: isSelected(d) }"
            ></i>
            <div class="voice_num">{{ index + 1 }}</div>
            <div class="sea-voice-play lf">
              <span class="sound-play"></span>
            </div>
            <div class="sea-voice-tit lf">
              <a
                :href="'/voice/detail/' + d.voiceId"
                class="hl"
                target="_blank"
                :title="`${d.voiceTitle}`"
                >{{ d.voiceTitle }}</a
              >
              <i data-video="undefined" class="pop_video"></i>
            </div>
            <div class="sea-voice-tea lf">
              <a
                class="hl"
                :title="d.nameExternal"
                :href="'dubbing/dateil/' + d.dubbingId"
                target="_blank"
                v-if="d.dubbingType == 1"
                >{{ d.nameExternal }}</a
              >
            </div>
            <div class="sea-voice-down lf">
              <a
                :href="getOSS() + d.filePath"
                target="_blank"
                download=".mp3"
                title="下载样音"
                >下载</a
              >
              <span class="rt">{{ d.downloadCount | toBigCount }}</span>
            </div>
            <div class="playCount lf">
              <i></i>
              <span class="rt">{{ d.playCount | toBigCount }}</span>
            </div>
            <div class="opacity" @click="selectItem(d)"></div>
          </li>
        </ul>
        <div class="empty_cop" v-if="datas.voice.length == 0">
          <p class="info">您暂无添加收藏过的声音哦~</p>
          <a href="/voice">去看看 >></a>
        </div>
      </div>
      <div class="album_area" v-show="type == 'album'">
        <div class="empty_cop" v-if="datas.album.length == 0">
          <p class="info">您暂无添加收藏过的合辑哦~</p>
          <a href="/">去看看 >></a>
        </div>
        <ul class="album-warp right_content" style="min-height: 600px">
          <li class="album_li" v-for="d in datas.album">
            <i
              class="select"
              @click="selectItem(d)"
              :class="{ on: isSelected(d) }"
            ></i>
            <a :href="'/album/detail/' + d.tranSpecialId" target="_blank">
              <div class="right_content_color">
                <img :src="imgPath(d.specialImgPath)" alt="" />
              </div>
              <div class="right_content_text">
                <p class="content_text_title">{{ d.specialName }}</p>
                <p>
                  <span>{{ d.specialKey }}</span>
                </p>
                <p style="padding-top: 20px; color: #9b9b9b">
                  共{{ d.specialCount }}条
                </p>
              </div>
            </a>
            <div class="opacity" @click="selectItem(d)"></div>
          </li>
        </ul>
      </div>
      <div class="page_wrap" style="margin: 0 0 80px 10px">
        <sd-pager :page-data="curPage" @page-change="pageChange"></sd-pager>
      </div>
    </div>
  </div>
</template>

<script type="es6">
   import { mapState, mapActions , mapGetters} from 'vuex'
   import sdPager from '../components/sdPager'
   import { util } from '../service/util'
   import { gPlayer } from '../plug/playerController'
 let API = util.api([
     'CUSTOMERFINDCOLLECTION',
     'CUSTOMERCANCELCOLLECTION',
     'GETCOLLECTIONBYCONDITION',
     'CUSTOMERCOLLECT'
   ]);
export default {
     name: 'collect-view',
     components: { sdPager },
     data () {
       return {
         type : 'dubber',
         waitingSelect: false,
         selectedItems:[],
         searchKey:'',
         datas: {
           dubber:[],
           voice: [],
           album: [],
         },
         pages: {
           dubber:{
               kw: '',
               pageNo: 1,
               pageSize:20,
               totalPage : 1
           },
           voice: {
               kw: '',
               pageNo: 1,
               pageSize:30,
               totalPage : 1
           },
           album: {
               kw: '',
               pageNo: 1,
               pageSize:20,
               totalPage : 1
           }
         },
         // 当前选中的页码
         curPage : {
           kw: '',
           pageNo: 1,
           pageSize: 20,
           totalPage: 1
         },

       }
     },
     computed: {
       ...mapState({
         userInfo : state => state.common.userInfo,
         log : state => state.common.log
       }),
       getPage() {
           let page = this.pages[this.type];
           return {
               pageNo: page.pageNo,
               pageSize: page.pageSize
           }
       },
       getData() {
           return this.datas[this.type];
       },
       getTypeId() {
           return {'dubber':1,'voice':2,'album':3}[this.type];
       },

       getTypeKey() {
           return {'dubber':'dubbingId','voice':'voiceId','album':'tranSpecialId'}[this.type];
       },
       // 被全选
       isSelectedAll() {
           let key = this.type;
           return this.datas[key].length == this.selectedItems.length && this.selectedItems.length;
       }
     },
     methods: {
       //全选操作
       checkAll(){
            let key = this.type;
            // 取消全选
            if(this.isSelectedAll){
               this.selectedItems = [];
               return;
            }
            // 全选
            this.selectedItems = [];
            this.datas[key].forEach(d => {
               this.selectedItems.push(d);
            })
        },
       /**
        * 切换收藏类型
        */
       ... util,
       changeType(type){
           this.selectedItems = [];
           this.type = type;
           this.curPage = this.pages[this.type];

           // 数据为空，加载数据
           if(!this.getData.length){
               this.doSearch();
           }
       },
       getIndex(item) {
         return this.selectedItems.indexOf(item);
       },
       isSelected(item) {
         // 是否被选中
         return this.getIndex(item) != -1;
       },
       typeChange() {
         if(this.waitingSelect){
           this.waitingSelect = false;
           this.selectedItems = [];
         } else {
           this.waitingSelect = true;
         }
       },
       selectItem(item) {
         if(!this.waitingSelect){
           return;
         }
         let i = this.selectedItems.indexOf(item);
         if(i != -1){
           this.selectedItems.splice(i,1);
         } else {
           this.selectedItems.push(item);
         }
       },
       // 批量删除
       doDelete() {
         let src = this.getData;
         let del = this.selectedItems;
         let ids = [];
         let _curType = this.type;
         del.forEach( d => {
           ids.push(d[this.getTypeKey]);
         })
         this.typeChange();
         // 未勾选
         if(!ids.length){
           return;
         }
         // 删除
         let param = {
           collectType: this.getTypeId,
           collectionIds: ids.join(',')
         }
         // cookie
         util.updateCollectCookie(this.getTypeId, ids,'remove');
         util.kAjax(API.CUSTOMERCANCELCOLLECTION, param, json => {
           this.changeType(_curType);
           this.doSearch();
         })
       },
       // 页码改变
       pageChange(index) {
           let page = this.pages[this.type];

           this.doSearch();
       },
       // searchType, 强制搜索类型
       doSearch(searchType) {
           let type = this.getTypeId,
               page = this.pages[this.type];
           let param = {
               collectType: type,
               page: this.getPage,
               caseString : this.searchKey
           }
           util.kAjax(API.CUSTOMERFINDCOLLECTION, param, json => {
               // 清空已经选择的东西
               this.selectedItems = [];
               let _data = json.data.datas,
                   _page = {
                       pageNo:json.data.pageNo,
                       totalPage : json.data.totalPage
                   }

               // 10.17剔除错误的空值
               _data.forEach((d,i)=>{
                   if(!d || d == null){
                       _data.splice(i,1);
                   }
               })

               if(type == 1){
                   let _this = this;
                   this.datas.dubber = _data;
                   let dubber = this.datas.dubber;
                   for(let a in dubber){
                       _this.$set(dubber[a],'hasCollect',true);
                   }
                   this.pages.dubber.totalPage = _page.totalPage;
                   this.pages.dubber.pageNo = _page.pageNo;
               } else if(type == 2){
                   this.datas.voice = _data;
                   this.pages.voice.totalPage = _page.totalPage;
                   this.pages.voice.pageNo = _page.pageNo;
                   util.addSoundData(_data);
               } else if(type == 3){
                   this.datas.album = _data;
                   this.pages.album.totalPage = _page.totalPage;
                   this.pages.album.pageNo = _page.pageNo;
               }
           })
       },
       searchItem(){
           let type = this.getTypeId;
           let param = {
               collectType : type,
               caseString : this.searchKey,
               page: this.getPage
           };
           util.kAjax(API.GETCOLLECTIONBYCONDITION,param,json=>{
               let _data = json.data.datas,
                   _page = {
                       pageNo:json.data.pageNo,
                       totalPage : json.data.totalPage
                   }

               // 10.17剔除null空值
               _data.forEach((d,i)=>{
                   if(!d || d == null){
                       _data.splice(i,1);
                   }
               })

               if(type == 1){
                   this.datas.dubber = _data;
                   this.pages.dubber.totalPage = _page.totalPage;
                   this.pages.dubber.pageNo = _page.pageNo;
                   let dubber = this.datas.dubber;
                   for(let a in dubber){
                       this.$set(dubber[a],'hasCollect',true);
                   }

               } else if(type == 2){
                   this.datas.voice = _data;
                   this.pages.voice.totalPage = _page.totalPage;
                   this.pages.voice.pageNo = _page.pageNo;
                   util.addSoundData(_data);
               } else if(type == 3){
                   this.datas.album = _data;
                   this.pages.album.totalPage = _page.totalPage;
                   this.pages.album.pageNo = _page.pageNo;
               }
           })
       },
       singleCollect(item){
           let param = {
               collectType:this.getTypeId,
               collectionIds:item.dubbingId
           };
           // 取消
           if(item.hasCollect){
               // cookie
               util.updateCollectCookie(this.getTypeId, item.dubbingId, 'remove');
               item.hasCollect = false;
               util.kAjax(API.CUSTOMERCANCELCOLLECTION,param,res=>{
                   if(res.status == 1){
                      item.hasCollect = false;
                   }
               })
           // 增加
           }else {
               util.updateCollectCookie(this.getTypeId, item.dubbingId, 'add');
               util.kAjax(API.CUSTOMERCOLLECT,{
                   collectType:this.getTypeId,
                   collectionId:item.dubbingId
               },res => {
                   if(res.status == 1){
                       item.hasCollect = true;
                   }
               })
           }
       }
     },
     watch: {
       searchKey(value) {
           if(!value){
               this.searchItem();
           }
       }
     },
     created() {
       this.changeType('dubber');
     }
   }
</script>



// WEBPACK FOOTER //
// CollectView.vue?bf2dc9ca